import { httpCreate } from './http';

const http = httpCreate('/srv/activity-mob-phone-white');

export const activityPhoneWhite = {
	// 单独新增白名单
	addPhoneWhite(activityId, params) {
		return http.post(`/single/${activityId}`, params);
	},
	// 已使用列表
	usedWhiteList(activityId, params) {
		return http.get(
			`/list/used/${activityId}?pageNum=${params.pageNum}&pageSize=${params.pageSize}&searchText=${params.searchText}`
		);
	},
	// 未使用列表
	unUsedWhiteList(activityId, params) {
		return http.get(
			`/list/unUsed/${activityId}?pageNum=${params.pageNum}&pageSize=${params.pageSize}&searchText=${params.searchText}`
		);
	},
	// 删除白名单
	deletePhoneWhite(activityId, isUsed, whiteListIds) {
		return http.delete(`/delete/${activityId}/${isUsed}`, { data: whiteListIds });
	},
	// 导入名单
	importPhoneWhite(activityId, data) {
		return http.post(`/import/${activityId}`, data);
	},
	// 清空未使用
	clearUnusedPhone(activityId) {
		return http.delete(`/clear/unUsed/${activityId}`);
	},
	// 清空已使用
	clearUsedPhone(activityId) {
		return http.delete(`/clear/usedClear/${activityId}`);
	},
};
